import { useState, useEffect } from "react";
import { client } from "../sanity/client";

function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    client.fetch(`*[_type == "project"]`).then((data) => {
      console.log(data);
      setProjects(data);
    });
  }, []);
  return (
    <>
      <p>
        <span className="prompt">ziad@portfolio:</span>
        <span className="path">~</span>
        <span className="command">$ cd projects</span>
      </p>
      <div className="section">
        {projects[0]?.projects?.map((project, index) => (
          <div key={index} className="section">
            <p>
              💡 <strong>{project.title}</strong>
              {project.subtitle && <> - {project.subtitle}</>}
              <br />
              {project.title === "Legal Aid" && (
                <>
                  {" "}
                  🏆 Intra-university champion <br />
                </>
              )}
              <span className="work-date">{project.date}</span>
              <br />
            </p>

            {project.description?.map((point, i) => (
              <p key={i}>→ {point}</p>
            ))}

            <p>
              → <strong>Tech stack</strong>: {project.techStack?.join(", ")}
            </p>

            {project.githubUrl && (
              <p>
                🔗 GitHub:{" "}
                <a href={project.githubUrl} target="_blank" rel="noreferrer">
                  View Repository
                </a>
              </p>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
export default Projects;
